module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tp01"
    }
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "OEBPS/images/li.jpg",
      "width": "436"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageAuthor",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NOAM CHOMSKY")])]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POWER SYSTEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "6",
      "src": "OEBPS/images/li.jpg",
      "width": "436"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "titlePageSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONVERSATIONS ON GLOBAL DEMOCRATIC UPRISINGS AND THE NEW CHALLENGES TO U.S. EMPIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageText"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INTERVIEWS WITH")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AVID")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ARSAMIAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "titlePagePublisher",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ETROPOLITAN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OOKS")]), _c('br'), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HENRY HOLT AND COMPANY • NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02a4c64c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780805096163_tp01.vue
// module id = 57
// module chunks = 0